__turbopack_context__.v({
  "lockup": "LogoReveal-module__y5TOwa__lockup",
  "logoImg": "LogoReveal-module__y5TOwa__logoImg",
  "logoWrap": "LogoReveal-module__y5TOwa__logoWrap",
  "stage": "LogoReveal-module__y5TOwa__stage",
  "wordmarkImg": "LogoReveal-module__y5TOwa__wordmarkImg",
  "wordmarkMask": "LogoReveal-module__y5TOwa__wordmarkMask",
});
